
export default [
  {
    name:"Stake",
    path: '/Stake',
    component: () => import('@/views/stake/index'),
    meta: { title: 'Stake', noCache: false, affix: false},
    children:[
      {
        path: '',
        redirect:"activeValidators"
      },
      {
        name:"activeValidators",
        path: 'activeValidators',
        component: () => import('@/views/stake/activeValidators/index.vue'),
        meta: { title: 'Active Validators', noCache: false, affix: false},
      },
      {
        name:"boosting",
        path: 'boosting',
        component: () => import('@/views/stake/boosting/index.vue'),
        meta: { title: 'Stake Boosting', noCache: false, affix: false},
      },
    ]
  },
  {
    name:"stakeProfile",
    path: '/Stake/profile',
    hidden:true,
    component: () => import('@/views/stake/profile/index.vue'),
    meta: { title: 'stakeProfile', noCache: false, affix: false},
  },

]
